import { useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation(); 
  if (location.pathname === "/resources" || location.pathname === "/vocabulary-daily") {
    return null;
  }
  return (
    <footer className="relative bg-black/95 backdrop-blur-md border-t border-cyan-400/30 shadow-neon-cyan overflow-hidden">
      {/* Cyberpunk grid background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `
            linear-gradient(cyan 1px, transparent 1px),
            linear-gradient(90deg, cyan 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px'
        }}></div>
      </div>
      
      {/* Animated top border */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-cyan-400 to-transparent animate-slide-right"></div>
      
      {/* Decorative elements */}
      <div className="absolute -top-20 -left-20 w-40 h-40 bg-gradient-to-br from-cyan-400/10 to-pink-400/10 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-gradient-to-br from-green-400/10 to-purple-400/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto text-center py-6 px-4 relative z-10">
        <div className="max-w-2xl mx-auto">
          <p className="text-gray-300 font-mono text-sm leading-relaxed">
            <span className="text-cyan-400 font-bold">{'>'}</span>{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-500 to-green-400 animate-gradient-x font-bold">
              &copy; {new Date().getFullYear()}
            </span>{" "}
            <span className="text-gray-400">All rights reserved by</span>{" "}
            <span className="text-cyan-400 font-bold tracking-wider">
              [CHIBA_SYSTEMS]
            </span>
          </p>
          <p className="text-gray-500 font-mono text-xs mt-2">
            <span className="text-pink-400">{'>'}</span>{" "}
            Educational & non-profit neural enhancement protocols{" "}
            <span className="text-cyan-400 animate-pulse">🐶</span>
          </p>
          
          {/* Tech-style footer decoration */}
          <div className="flex items-center justify-center gap-2 mt-4">
            <div className="w-8 h-px bg-gradient-to-r from-transparent via-cyan-400 to-transparent"></div>
            <div className="w-2 h-2 border border-cyan-400/50 rounded-full bg-cyan-400/20 animate-pulse"></div>
            <div className="w-16 h-px bg-gradient-to-r from-cyan-400 via-pink-400 to-green-400"></div>
            <div className="w-2 h-2 border border-pink-400/50 rounded-full bg-pink-400/20 animate-pulse delay-500"></div>
            <div className="w-8 h-px bg-gradient-to-r from-transparent via-green-400 to-transparent"></div>
          </div>
        </div>
      </div>
    </footer>
  );
}
